import { NavUser } from '@/components/nav-user';
import { TeamSwitcher } from '@/components/team-switcher';
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarRail,
  useSidebar,
} from '@/components/ui/sidebar';
import {
  Building2,
  FileText,
  GalleryVerticalEnd,
  Landmark,
  LayoutDashboard,
  Package,
  Users,
} from 'lucide-react';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const data = {
  user: {
    name: 'Admin',
    email: 'admin@trkinvoicia.com',
    avatar: '/avatar/user.png',
  },
  teams: [
    {
      name: 'TRK Invoicia',
      logo: GalleryVerticalEnd,
      plan: 'Invoice Management',
    },
  ],
  navMain: [
    {
      title: 'Dashboard',
      url: '/dashboard',
      icon: LayoutDashboard,
    },
    {
      title: 'Companies',
      url: '/companies',
      icon: Building2,
    },
    {
      title: 'Customers',
      url: '/customers',
      icon: Users,
    },
    {
      title: 'Items',
      url: '/items',
      icon: Package,
    },
    {
      title: 'Bank Details',
      url: '/bank-details',
      icon: Landmark,
    },
    {
      title: 'Invoices',
      url: '/invoices',
      icon: FileText,
    },
  ],
};

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { setOpenMobile } = useSidebar();
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = React.useCallback(
    (path: string) => location.pathname === path || location.pathname.startsWith(path + '/'),
    [location.pathname]
  );

  const handleClick = React.useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>, url: string) => {
      // allow middle click / new tab
      if (e.button === 1 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) {
        return;
      }

      e.preventDefault();

      // Close mobile sidebar when a menu item is clicked
      setOpenMobile(false);
      navigate(url);
    },
    [navigate, setOpenMobile]
  );

  return (
    <Sidebar collapsible="icon" {...props}>
      {/* Header */}
      <SidebarHeader>
        <TeamSwitcher teams={data.teams} />
      </SidebarHeader>

      {/* Content */}
      <SidebarContent>
        <SidebarGroup>
          {/* <SidebarGroupLabel>Main</SidebarGroupLabel> */}
          <SidebarGroupContent>
            <SidebarMenu>
              {data.navMain.map((item) => {
                const Icon = item.icon;
                return (
                  <SidebarMenuItem key={item.url}>
                    <SidebarMenuButton
                      asChild
                      isActive={isActive(item.url)}
                      className="h-9 transition-[background-color,color] duration-150 data-[active=true]:bg-sidebar-primary data-[active=true]:text-sidebar-primary-foreground [&:not([data-active=true])]:hover:bg-primary [&:not([data-active=true])]:hover:text-primary-foreground"
                      tooltip={item.title}
                    >
                      <a
                        href={item.url}
                        onClick={(e) => handleClick(e, item.url)}
                        className="flex items-center gap-2"
                      >
                        <Icon className="!h-5 !w-5" />
                        <span className="text-[15px] leading-[22px]">{item.title}</span>
                      </a>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                );
              })}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>

      {/* Footer */}
      <SidebarFooter>
        <NavUser user={data.user} />
      </SidebarFooter>

      <SidebarRail />
    </Sidebar>
  );
}
